// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"53":"c8b54239","237":"cd31b7b8","656":"130abff0","736":"1c697591","924":"bd380557"}[chunkId] + ".css";
};